// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__3fjGk","enableTransition":"Link_enableTransition__BmC-B","active":"Link_active__1tGLp","redesigned":"Link_redesigned__1OmXl"};